
import Vue from 'vue';
import * as PhotoStore from 'src/store/modules/photos/store';

export default Vue.extend({
  methods: {
    async asyncFileUpload(image: File) {
      // FIXME Why is return required?
      const r = await this.$store.dispatch(
        PhotoStore.CreatePhoto.namespaced({ image })
      );
      return r;
    },
  },
});
